var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-modal",
      on: {
        click: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "product-modal-container no-scrollbar",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "main-container" }, [
            _c("div", { staticClass: "second-container mobile" }, [
              _c("div", { staticClass: "info-container" }, [
                !_vm.isSelected && !_vm.canAdd
                  ? _c("p", { staticClass: "oops" }, [_vm._v("Oops!")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.title
                  ? _c("p", { staticClass: "main-title" }, [
                      _vm._v(_vm._s(_vm.title))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "product-title" }, [
                  _vm._v(_vm._s(_vm.product.title))
                ]),
                _vm._v(" "),
                _vm.maxQty > 1 && !_vm.showAllVariants
                  ? _c("div", { staticClass: "box-qty-input-container" }, [
                      _c(
                        "button",
                        {
                          attrs: { disabled: _vm.selectedQty < 2 },
                          on: {
                            click: function($event) {
                              return _vm.incrementBoxQty(false)
                            }
                          }
                        },
                        [_vm._v("-")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedQty,
                            expression: "selectedQty"
                          }
                        ],
                        attrs: { disabled: true, type: "number", min: "1" },
                        domProps: { value: _vm.selectedQty },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.selectedQty = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          attrs: { disabled: _vm.selectedQty == _vm.maxQty },
                          on: {
                            click: function($event) {
                              return _vm.incrementBoxQty(true)
                            }
                          }
                        },
                        [_vm._v("+")]
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "first-container" }, [
              _c(
                "div",
                { staticClass: "image-container mobile" },
                [
                  _c(
                    "VueSlickCarousel",
                    {
                      attrs: {
                        infinite: true,
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        draggable: true,
                        dots: true
                      }
                    },
                    _vm._l(_vm.product.images, function(image) {
                      return _c("img", {
                        key: image.id,
                        staticClass: "main-image",
                        attrs: { src: image.src }
                      })
                    }),
                    0
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "image-container desktop" }, [
                _c("img", {
                  staticClass: "main-image",
                  attrs: { src: _vm.currentMainImage }
                }),
                _vm._v(" "),
                _vm.product.images.length > 1
                  ? _c(
                      "div",
                      { staticClass: "extra-images-container" },
                      _vm._l(_vm.product.images, function(image) {
                        return _c("img", {
                          key: image.id,
                          staticClass: "extra-image",
                          class:
                            image.src == _vm.currentMainImage ? "selected" : "",
                          attrs: { src: image.src },
                          on: {
                            click: function($event) {
                              return _vm.selectImage(image.src)
                            }
                          }
                        })
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "second-container",
                class: _vm.showAllVariants && _vm.hasVariants ? "reverse" : ""
              },
              [
                _c(
                  "div",
                  { staticClass: "info-container" },
                  [
                    !_vm.isSelected && !_vm.canAdd
                      ? _c("p", { staticClass: "oops desktop" }, [
                          _vm._v("Oops!")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.title
                      ? _c("p", { staticClass: "main-title desktop" }, [
                          _vm._v(_vm._s(_vm.title))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("p", { staticClass: "product-title desktop" }, [
                      _vm._v(_vm._s(_vm.product.title))
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "main-description",
                      domProps: { innerHTML: _vm._s(_vm.description) }
                    }),
                    _vm._v(" "),
                    _vm.showAllVariants && _vm.hasVariants
                      ? [
                          _c("div", { staticClass: "variant-container" }, [
                            _c("p", { staticClass: "variant-title" }, [
                              _vm._v(
                                "Choose options: (Max: " +
                                  _vm._s(_vm.maxQty) +
                                  ")"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "sizes-selection-container" },
                              _vm._l(_vm.displaySizes, function(variant, i) {
                                return _c(
                                  "div",
                                  { staticClass: "size-selection" },
                                  [
                                    _c("p", [_vm._v(_vm._s(variant.name))]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.displaySizes[i].qty,
                                          expression: "displaySizes[i].qty"
                                        }
                                      ],
                                      attrs: {
                                        min: "0",
                                        max: variant.maxQty,
                                        type: "number"
                                      },
                                      domProps: {
                                        value: _vm.displaySizes[i].qty
                                      },
                                      on: {
                                        input: [
                                          function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.displaySizes[i],
                                              "qty",
                                              $event.target.value
                                            )
                                          },
                                          function($event) {
                                            return _vm.validateVariantQty(i)
                                          }
                                        ]
                                      }
                                    })
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        ]
                      : [
                          _vm.hasVariants
                            ? _c(
                                "p",
                                {
                                  staticClass: "variant-text",
                                  class: _vm.showAlert ? "red" : ""
                                },
                                [_vm._v("Please choose one")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasVariants
                            ? _c("div", [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedVariant,
                                        expression: "selectedVariant"
                                      }
                                    ],
                                    attrs: { id: "variantSelector" },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.selectedVariant = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  _vm._l(_vm.variantOptions, function(variant) {
                                    return _c(
                                      "option",
                                      {
                                        key: variant.id,
                                        domProps: { value: variant }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            variant.title
                                              .replaceAll("Price /", "")
                                              .replaceAll("Happy Choice /", "")
                                          )
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.extraProperties.length > 0
                            ? _c(
                                "div",
                                _vm._l(_vm.extraProperties, function(
                                  property,
                                  i
                                ) {
                                  return _c("div", [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "variant-text",
                                        class: _vm.showExtraAlert ? "red" : ""
                                      },
                                      [_vm._v(_vm._s(property.name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.propertiesSelected[i],
                                            expression: "propertiesSelected[i]"
                                          }
                                        ],
                                        on: {
                                          change: [
                                            function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                _vm.propertiesSelected,
                                                i,
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                            function($event) {
                                              return _vm.changeProperty(
                                                $event,
                                                property
                                              )
                                            }
                                          ]
                                        }
                                      },
                                      _vm._l(property.values, function(
                                        variant
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: variant,
                                            domProps: { value: variant }
                                          },
                                          [_vm._v(_vm._s(variant))]
                                        )
                                      }),
                                      0
                                    )
                                  ])
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.extraInputs, function(input) {
                            return _c(
                              "div",
                              {
                                key: input.name,
                                staticClass:
                                  "form-group flex flex-column m-t-05rem"
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "body-small",
                                    class: _vm.showExtraAlert
                                      ? "color-warning"
                                      : "",
                                    attrs: { for: input.name }
                                  },
                                  [_vm._v(_vm._s(input.label || input.name))]
                                ),
                                _vm._v(" "),
                                ["text", "number", "color"].includes(input.type)
                                  ? [
                                      input.type === "checkbox"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.formData[input.name],
                                                expression:
                                                  "formData[input.name]"
                                              }
                                            ],
                                            attrs: {
                                              id: input.name,
                                              type: "checkbox"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.formData[input.name]
                                              )
                                                ? _vm._i(
                                                    _vm.formData[input.name],
                                                    null
                                                  ) > -1
                                                : _vm.formData[input.name]
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a =
                                                    _vm.formData[input.name],
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.formData,
                                                        input.name,
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.formData,
                                                        input.name,
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.formData,
                                                    input.name,
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          })
                                        : input.type === "radio"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.formData[input.name],
                                                expression:
                                                  "formData[input.name]"
                                              }
                                            ],
                                            attrs: {
                                              id: input.name,
                                              type: "radio"
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.formData[input.name],
                                                null
                                              )
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.$set(
                                                  _vm.formData,
                                                  input.name,
                                                  null
                                                )
                                              }
                                            }
                                          })
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.formData[input.name],
                                                expression:
                                                  "formData[input.name]"
                                              }
                                            ],
                                            attrs: {
                                              id: input.name,
                                              type: input.type
                                            },
                                            domProps: {
                                              value: _vm.formData[input.name]
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.formData,
                                                  input.name,
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          }),
                          _vm._v(" "),
                          _vm.maxQty > 1
                            ? _c(
                                "div",
                                {
                                  staticClass: "box-qty-input-container desktop"
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      attrs: { disabled: _vm.selectedQty < 2 },
                                      on: {
                                        click: function($event) {
                                          return _vm.incrementBoxQty(false)
                                        }
                                      }
                                    },
                                    [_vm._v("-")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedQty,
                                        expression: "selectedQty"
                                      }
                                    ],
                                    attrs: {
                                      disabled: true,
                                      type: "number",
                                      min: "1"
                                    },
                                    domProps: { value: _vm.selectedQty },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.selectedQty = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      attrs: {
                                        disabled: _vm.selectedQty == _vm.maxQty
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.incrementBoxQty(true)
                                        }
                                      }
                                    },
                                    [_vm._v("+")]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.showAllVariants && _vm.hasVariants
                  ? [
                      _c("div", { staticClass: "buttons-container" }, [
                        _vm.allQtySelected === 0
                          ? _c(
                              "button",
                              {
                                staticClass: "happybox-button green disabled",
                                attrs: { disabled: "disabled" }
                              },
                              [_vm._v("Pick Your Shirts Above")]
                            )
                          : _vm.showVariantSubmitButton
                          ? _c(
                              "button",
                              {
                                staticClass: "happybox-button green border",
                                on: {
                                  click: function($event) {
                                    return _vm.addAllVariants()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "Submit " +
                                    _vm._s(_vm.allQtySelected) +
                                    " Shirts"
                                )
                              ]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "happybox-button green border",
                                class: _vm.isLoading ? "isLoading" : "",
                                on: {
                                  click: function($event) {
                                    return _vm.checkout()
                                  }
                                }
                              },
                              [_vm._v("Next Step")]
                            )
                      ])
                    ]
                  : [
                      _c("div", { staticClass: "buttons-container" }, [
                        _vm.maxQty > 1 &&
                        _vm.isSelected &&
                        _vm.availableCapacity > 0 &&
                        _vm.cartDiff == 0
                          ? _c(
                              "button",
                              {
                                staticClass: "happybox-button green border",
                                on: {
                                  click: function($event) {
                                    return _vm.closeModal()
                                  }
                                }
                              },
                              [_vm._v("Add More Gifts")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.maxQty > 1 &&
                        _vm.cartDiff != 0 &&
                        _vm.isSelected &&
                        _vm.canAdd
                          ? _c(
                              "button",
                              {
                                staticClass: "happybox-button green border",
                                on: {
                                  click: function($event) {
                                    return _vm.selectProduct()
                                  }
                                }
                              },
                              [_vm._v("Update gift quantity")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.maxQty > 1 &&
                        _vm.cartDiff != 0 &&
                        _vm.isSelected &&
                        !_vm.canAdd
                          ? _c(
                              "button",
                              {
                                staticClass: "happybox-button green border",
                                on: {
                                  click: function($event) {
                                    return _vm.selectProduct(true)
                                  }
                                }
                              },
                              [_vm._v("Clean cart and update gift")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        (_vm.isSelected && !_vm.isBundle) ||
                        (_vm.isSelected &&
                          _vm.isBundle &&
                          _vm.bundleRemaining == 0 &&
                          _vm.tabCapacity == 0)
                          ? _c(
                              "button",
                              {
                                staticClass: "happybox-button border",
                                class: [
                                  _vm.isLoading ? "isLoading" : "",
                                  _vm.availableCapacity != 0 ||
                                  (_vm.maxQty > 1 &&
                                    _vm.cartDiff != 0 &&
                                    _vm.isSelected)
                                    ? "gray"
                                    : "green"
                                ],
                                attrs: {
                                  disabled:
                                    _vm.availableCapacity != 0 ||
                                    (_vm.maxQty > 1 &&
                                      _vm.cartDiff != 0 &&
                                      _vm.isSelected)
                                },
                                on: { click: _vm.checkout }
                              },
                              [_vm._v("Next Step: Add your Address")]
                            )
                          : _vm.isSelected &&
                            _vm.isBundle &&
                            _vm.bundleRemaining > 0 &&
                            _vm.tabCapacity == 0
                          ? _c(
                              "button",
                              {
                                staticClass: "happybox-button green border",
                                on: { click: _vm.nextStep }
                              },
                              [_vm._v("Next Step")]
                            )
                          : _vm.isSelected &&
                            _vm.isBundle &&
                            _vm.bundleRemaining > 0 &&
                            _vm.tabCapacity > 0
                          ? _c(
                              "button",
                              {
                                staticClass: "happybox-button green border",
                                on: {
                                  click: function($event) {
                                    return _vm.closeModal()
                                  }
                                }
                              },
                              [_vm._v("Pick next gift")]
                            )
                          : _vm.canAdd
                          ? _c(
                              "button",
                              {
                                staticClass: "happybox-button green border",
                                on: {
                                  click: function($event) {
                                    return _vm.selectProduct()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.isOneRedeem
                                      ? "Submit"
                                      : "Redeem this gift"
                                  )
                                )
                              ]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "happybox-button green border",
                                on: {
                                  click: function($event) {
                                    return _vm.selectProduct(true)
                                  }
                                }
                              },
                              [_vm._v("Replace with this gift")]
                            )
                      ])
                    ]
              ],
              2
            ),
            _vm._v(" "),
            _c("img", {
              staticClass: "close",
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652",
                alt: "x"
              },
              on: {
                click: function($event) {
                  return _vm.closeModal()
                }
              }
            })
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }